import CityDirectory from "../components/CityDirectory";

export default function IndiaCities() {
  return (
    <CityDirectory
      id="india-cities"
      title="India City Guides"
      subtitle="Major metros, state capitals, tourism centers, pilgrimage cities, business hubs and important Tier-2/3 cities — grouped by region. Renamed cities are listed under both old and new names and open the same guide."
      endpoint="/geo/india-cities"
      country="India"
      searchPlaceholder="Search a city or state — try Cochin, Bangalore, Allahabad…"
      accent="#ff9933"
      docTitle="India City Guides — 137 Cities by Region | TravelerPulse"
    />
  );
}
